import { defineComponent as _defineComponent } from 'vue'
import { computed } from '@nuxtjs/composition-api';
import { SelectorType } from '@/components/partials/optional-anonymity/ProfileSelector/types';

type ProfileSelectorToggleProps = {
  withAvatar: boolean;
  isLoading: boolean;
  name: string;
  isDisabled?: boolean;
  hint?: string;
  avatarUrl?: string | null;
  size?: 'sm' | 'md';
  type?: SelectorType;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileSelectorToggle',
  props: {
    withAvatar: { type: Boolean },
    isLoading: { type: Boolean },
    name: null,
    isDisabled: { type: Boolean, default: false },
    hint: { default: '' },
    avatarUrl: { default: null },
    size: { default: 'sm' },
    type: { default: SelectorType.post }
  },
  setup(__props: any) {

const props = __props as { withAvatar: boolean, isLoading: boolean, name: string, isDisabled: boolean, hint: string, avatarUrl: string | null, size: 'sm' | 'md', type: SelectorType };

const BravadoSkeleton = () => import('@/components/common/BravadoSkeleton/BravadoSkeleton.vue');
const AngleIcon = () => import('@/assets/svg/angle-down.vue.svg');
const ProfileSelectorAvatar = () =>
  import('@/components/partials/optional-anonymity/ProfileSelector/ProfileSelectorAvatar.vue');



const textStyles = computed(() => ({
  'profile-selector-toggle__name': true,
  'profile-selector-toggle__name--disabled': props.isDisabled,
}));

const mainTextVariant = computed(() => {
  switch (props.size) {
    case 'sm':
      return 'subhead-semibold';
    case 'md':
      return 'body-semibold';
  }
});

return { __sfc: true,BravadoSkeleton, AngleIcon, ProfileSelectorAvatar, props, textStyles, mainTextVariant }
}

})